<template>
  <a-card :style="`min-height:${chartMinHeight};`">
    <base-chart
      ref="analysisChart"
      id="analysis-chart"
      domId="analysis-chart"
      :loading="loading"
      :chartData="chartData"
      :chartConfig="chartConfig" />
  </a-card>
</template>

<script>
import * as R from 'ramda'
import currencyRequest from '@Bill/mixins/currencyRequest'
import { ANALYSIS_GROUPT_TYPE_MAP } from '@Bill/constants'
import { numerify } from '@/filters'
import { getChartTooltipPosition } from '@/utils/echart'
import AnalysisesMixin from '../mixins/analysises'

function transformAndSumData (data, billTypes) {
  function collectValues (node, valueMap) {
    if (Array.isArray(node.data)) {
      if (node.data[0]?.date_info !== undefined) {
        node.data.forEach(item => {
          const key = item.date_info
          valueMap[key] = { ...(valueMap[key] || {}) }
          billTypes.forEach(billType => {
            valueMap[key][billType] = (valueMap[key][billType] || 0) + (item[billType] || 0)
          })
        })
      } else {
        node.data.forEach(child => {
          collectValues(child, valueMap)
        })
      }
    }
  }
  const result = data.map(item => {
    const valueMap = {}
    collectValues(item, valueMap)
    let total = 0
    const list = []
    Object.keys(valueMap).forEach(key => {
      total += valueMap[key][billTypes[0]]
      list.push({
        date_info: key,
        ...valueMap[key],
      })
    })
    return {
      name: item.name,
      stat_value_sum: total,
      data: list,
    }
  })
  result.sort((a, b) => {
    return b.stat_value_sum - a.stat_value_sum
  })
  return result
}

function transformAndSumData2 (data, billTypes) {
  return data.map(item => {
    return {
      name: item.name,
      data: transformAndSumData(item.data, billTypes),
    }
  })
}

export default {
  name: 'AnalysisesChart',
  components: {
  },
  mixins: [currencyRequest, AnalysisesMixin],
  props: {
    originDataList: {
      type: Array,
      require: true,
    },
    dataList: {
      type: Array,
      require: true,
    },
    formData: {
      type: Object,
      require: true,
    },
    loading: {
      type: Boolean,
    },
    tagGroupParams: Object,
    projectTagGroupParams: Object,
    instanceTagGroupParams: Object,
    chartConfigs: {
      type: Object,
      default: () => { return {} },
    },
    billType: {
      type: Array,
    },
    dataGroup: {
      type: Array,
      default: () => ([]),
    },
  },
  data () {
    return {
      chartData: {
        columns: [],
        rows: [],
      },
      colors: ['#ADD1F3', '#F3CBAD', '#F3ADB2', '#ADE4B6', '#ADAEF3', '#A593E0', '#7f9eb2', '#f6ea8c', '#a5dff9', '#77AAAD', '#ccc'],
    }
  },
  computed: {
    billTypes () {
      // if (this.formData.groups.some(item => item.group === 'aggregate_usage_unit')) {
      //   return ['aggregate_usage', ...this.billType]
      // }
      return this.billType
    },
    yAxis () {
      // y轴
      const yAxis = []
      if (this.showAsDimension1) {
        // 按维度展示，一个聚合项，展示为费用类型
        return this.billTypes || []
      } else {
        const dataList = this.originDataList || []
        dataList.map(item => {
          // 按天按月展示，展示为第一维度
          // 按维度展示，两个聚合项，展示为第二维度
          if (this.showAsDimension2) {
            item.data.map(item1 => {
              if (!yAxis.includes(item1.name)) {
                yAxis.push(item1.name)
              }
            })
          } else {
            if (!yAxis.includes(item.name)) {
              yAxis.push(item.name)
            }
          }
        })
      }
      return yAxis
    },
    yAxisColorMap () {
      const yAxisColorMap = {}
      this.yAxis.map((name, index) => {
        yAxisColorMap[name] = this.colors[index] || '#ccc'
      })
      return yAxisColorMap
    },
    chartMinHeight () {
      return this.chartConfigs.height || '400px'
    },
    chartConfig () {
      const { series, xAxis, top10YAxis, yAxisColorMap } = this.getSeriesData(this.originDataList, this.billTypes)
      return {
        height: '400px',
        width: '100%',
        legend: {
          show: true,
          type: 'scroll',
          formatter: (seriesName) => {
            const name = seriesName
            if (this.showAsDimension1) {
              return this.$te(`bill.bill_type.${name}`) ? this.$t(`bill.bill_type.${name}`) : name
            } else if (this.showAsDimension2) {
              return this.getNameI18n(name, this.formData.groups[1].group)
            }
            return this.getNameI18n(name, this.formData.groups[0].group)
          },
          data: top10YAxis.map(key => {
            return {
              name: key,
              itemStyle: {
                color: yAxisColorMap[key],
              },
            }
          }),
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            shadowStyle: {
              color: 'rgb(77, 161, 255)',
              opacity: 0.1,
            },
          },
          position: (point, params, dom, rect, size) => {
            if (!params || !params.length || !params[0] || !size) {
              dom.innerHTML = ''
              return point
            }
            dom.style.border = 'none'
            dom.style.backgroundColor = 'transparent'
            const data = {}
            const series = params.map(item => {
              if (!item || !item.seriesId) return null
              item.value = item.value || 0
              const nameType = item.seriesId.split('->')
              item.seriesName = nameType[0]
              item.type = nameType[1]
              if (!data[item.seriesName]) {
                data[item.seriesName] = { [item.type]: item.value, marker: item.marker || '' }
              } else {
                data[item.seriesName][item.type] = item.value
              }
              return item
            }).filter(Boolean)
            const colLabels = Object.keys(data)
            const billTypes = this.billTypes || []

            if (series.length === 0 || colLabels.length === 0 || !size.contentSize) {
              dom.innerHTML = ''
              return point
            }
            let tableStr = '<table style="color: #5D6F80;border:solid #bbb;border-width:1px 0 0 1px"><thead><tr>'
            const groupIndex = this.showAsDimension2 ? 1 : 0
            const groupKey = this.formData.groups[groupIndex]?.group
            let groupTitle = ''
            if (this.showAsDimension1) {
              groupTitle = this.$t('bill.bill_type')
            } else if (groupKey === 'aggregate_usage_unit') {
              groupTitle = this.$t('meter.aggregate_usage_unit')
            } else {
              groupTitle = ANALYSIS_GROUPT_TYPE_MAP[groupKey]?.value || this.$t('bill.text_72')
            }
            // 表头
            tableStr += `<th style="border:solid #bbb;border-width:0 1px 1px 0">${groupTitle}</th>`
            if (this.showAsDimension1) {
              // 表头
              tableStr += `<th style="border:solid #bbb;border-width:0 1px 1px 0;text-align:right">${this.$t('bill.text_2')}</th>`
              tableStr += '</tr></thead><tbody>'
              // 表格内容
              colLabels.map(name => {
                tableStr += `<tr><td style="max-width:150px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;border:solid #bbb;border-width:0 1px 1px 0">${this.$t(`bill.bill_type.${name}`)}</td>`
                tableStr += `<td style="text-align:right;border:solid #bbb;border-width:0 1px 1px 0">${this.currencySign} ${numerify(data[name][name], '0,0.00')}</td></tr>`
              })
            } else {
              const tableList = []
              const totalMap = {}
              // 表头
              billTypes.map(type => {
                tableStr += `<th style="border:solid #bbb;border-width:0 1px 1px 0;text-align:right">${this.$t(`bill.bill_type.${type}`)}</th>`
              })
              tableStr += '</tr></thead><tbody>'
              // 表格内容
              colLabels.map(name => {
                if (!data[name].stat_value && !data[name].stat_value_sec && !data[name].gross_value && !data[name].paid_value && !data[name].discount_value && !data[name].aggregate_usage) return
                const row = [`${data[name].marker}${this.getNameI18n(name, this.formData.groups[groupIndex]?.group || '')}`]
                billTypes.map(type => {
                  const value = data[name][type] || 0
                  totalMap[type] = (totalMap[type] || 0) + value
                  row.push(value)
                })
                tableList.push(row)
              })
              tableList.map(row => {
                tableStr += `<tr><td style="max-width:150px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;border:solid #bbb;border-width:0 1px 1px 0">${row[0]}</td>`
                billTypes.map((type, index) => {
                  if (type === 'aggregate_usage') {
                    tableStr += `<td style="text-align:right;border:solid #bbb;border-width:0 1px 1px 0">${numerify(row[index + 1], '0.00')}</td>`
                  } else {
                    tableStr += `<td style="text-align:right;border:solid #bbb;border-width:0 1px 1px 0">${this.currencySign} ${numerify(row[index + 1], '0,0.00')}</td>`
                  }
                })
                tableStr += '</tr>'
              })
              // 总计
              tableStr += '<tr><td style="border:solid #bbb;border-width:0 1px 1px 0">总计</td>'
              billTypes.map((type, index) => {
                if (type === 'aggregate_usage') {
                  tableStr += `<td style="text-align:right;border:solid #bbb;border-width:0 1px 1px 0">${numerify(totalMap[type], '0.00')}</td>`
                } else {
                  tableStr += `<td style="text-align:right;border:solid #bbb;border-width:0 1px 1px 0">${this.currencySign} ${numerify(totalMap[type], '0,0.00')}</td>`
                }
              })
              tableStr += '</tr>'
            }
            tableStr += '</tbody></table>'
            let title = params[0]?.name || ''
            if (this.showAsDimension2 && title) {
              title = this.getNameI18n(title, this.formData.groups[0]?.group)
            }
            const wrapper = `<div class="chart-tooltip-wrapper">
                          <div style="color: #5D6F80;margin-bottom:5px">${title}</div>
                          <div class="lines-wrapper">${tableStr}</div>
                        </div>`
            dom.innerHTML = wrapper
            if (size && size.contentSize && size.contentSize.length >= 2) {
              const originHeight = size.contentSize[1]
              if (!this.showAsDimension1) {
                size.contentSize[1] = (originHeight - 44) / billTypes.length + 44
                size.contentSize[0] = size.contentSize[0] - 50 + billTypes.length * 50
              }
              return getChartTooltipPosition(point, dom, size, false)
            }
            return point
          },
        },
        xAxis: [
          {
            type: 'category',
            axisLabel: {},
            data: xAxis.map(key => {
              if (this.showAsDimension2 || this.showAsDimension1) {
                return this.getNameI18n(key, this.formData.groups[0].group)
              }
              return key
            }),
          },
        ],
        yAxis: [
          {
            type: 'value',
          },
        ],
        series,
        ...this.chartConfigs,
      }
    },
  },
  watch: {
    originDataList: {
      deep: true,
      handler () {
        this.initChartData()
      },
      immediate: true,
    },
    billTypes () {
      this.initChartData()
    },
  },
  methods: {
    getSeriesData (data = [], showBillTypes = []) {
      const dataList = this.groupLen > 1 && this.showAsDimension2 ? transformAndSumData2(data, showBillTypes) : transformAndSumData(data, showBillTypes)
      const series = []
      const xAxis = []
      const yAxis = this.yAxis || []
      let top10YAxis = []
      const yAxisColorMap = {}
      if (dataList.length) {
        dataList.map((item, index) => {
          // x轴，按天按月展示为时间
          // 按维度且一个聚合项，展示为第一维度
          // 按维度且两个聚合项，展示为第一维度
          if (this.showAsDimension2 || this.showAsDimension1) {
            xAxis.push(item.name)
          } else if (index === 0) {
            if (item.data && item.data.length && !item.data[0].data) {
              item.data.map(item1 => {
                xAxis.push(item1.date_info)
              })
            } else if (item.data && item.data.length && item.data[0].data && item.data[0].data.length) {
              item.data[0].data.map(item1 => {
                xAxis.push(item1.date_info)
              })
            }
          }
        })
        // xAxis排序
        xAxis.sort((a, b) => a.localeCompare(b, 'zh-CN'))
        // 聚合数据
        let data = []
        if (this.showAsDimension1) {
          // 整理series
          showBillTypes.map(type => {
            top10YAxis.push(type)
            const seriesItem = {
              name: type,
              type: 'bar',
              emphasis: {
                focus: 'series',
              },
              data: [],
              barMaxWidth: 30,
              id: `${type}->${type}`,
            }
            xAxis.map(name => {
              const targetList = dataList.filter(item => item.name === name)
              if (targetList.length === 1) {
                let value = 0
                targetList[0].data.map(item => {
                  value += item[type] || 0
                })
                seriesItem.data.push(value)
              } else {
                seriesItem.data.push(0)
              }
            })
            series.push(seriesItem)
          })
        } else {
          yAxis.map(y => {
            const row = { name: y, data: [] }
            xAxis.map(x => {
              const targetData = {
                stat_value: 0,
                stat_value_sec: 0,
                gross_value: 0,
                paid_value: 0,
                discount_value: 0,
              }
              // 按维度展示
              if (this.showAsDimension2) {
                const targetX = dataList.filter(item => item.name === x)
                if (targetX.length === 1) {
                  const targetY = targetX[0].data.filter(item => item.name === y)
                  if (targetY.length === 1) {
                    targetY[0].data.map(item => {
                      targetData.stat_value += item.stat_value || 0
                      targetData.stat_value_sec += item.stat_value_sec || 0
                      targetData.gross_value += item.gross_value || 0
                      targetData.paid_value += item.paid_value || 0
                      targetData.discount_value += item.discount_value || 0
                    })
                  }
                }
              } else if (dataList[0].data.length && !dataList[0].data[0].data) { // 按天月、一个维度
                const targetX = dataList.filter(item => item.name === y)
                if (targetX.length === 1) {
                  targetX[0].data.map(item => {
                    if (item.date_info === x) {
                      targetData.stat_value += item.stat_value || 0
                      targetData.stat_value_sec += item.stat_value_sec || 0
                      targetData.gross_value += item.gross_value || 0
                      targetData.paid_value += item.paid_value || 0
                      targetData.discount_value += item.discount_value || 0
                    }
                  })
                }
              } else if (dataList[0].data.length && dataList[0].data[0].data && dataList[0].data[0].data.length) {
                const targetX = dataList.filter(item => item.name === y)
                if (targetX.length === 1) {
                  targetX[0].data.map(item => {
                    item.data.map(item1 => {
                      if (item1.date_info === x) {
                        targetData.stat_value += item1.stat_value || 0
                        targetData.stat_value_sec += item1.stat_value_sec || 0
                        targetData.gross_value += item1.gross_value || 0
                        targetData.paid_value += item1.paid_value || 0
                        targetData.discount_value += item1.discount_value || 0
                      }
                    })
                  })
                }
              }
              row.data.push({
                name: x,
                stat_value: 0,
                stat_value_sec: 0,
                gross_value: 0,
                paid_value: 0,
                discount_value: 0,
                ...targetData,
              })
            })
            data.push(row)
          })
          data.map(item => {
            let sum = 0
            const type = showBillTypes[0] || 'stat_value'
            item.data.map(row => {
              sum += row[type] || 0
            })
            item.sum = sum
          })
          data.sort((a, b) => b.sum - a.sum)
          // 取前十个和other
          const top10DataList = data.slice(0, 10)
          const otherDataList = data.slice(10)
          if (otherDataList.length) {
            const otherData = { name: this.$t('bill.other'), data: [] }
            const dataMap = {}
            otherDataList.map(item => {
              item.data.map(col => {
                const name = col.name
                if (!dataMap[name]) dataMap[name] = {}
                dataMap[name].stat_value = (dataMap[name].stat_value || 0) + (col.stat_value || 0)
                dataMap[name].stat_value_sec = (dataMap[name].stat_value_sec || 0) + (col.stat_value_sec || 0)
                dataMap[name].gross_value = (dataMap[name].gross_value || 0) + (col.gross_value || 0)
                dataMap[name].paid_value = (dataMap[name].paid_value || 0) + (col.paid_value || 0)
                dataMap[name].discount_value = (dataMap[name].discount_value || 0) + (col.discount_value || 0)
              })
            })
            const keys = Object.keys(dataMap)
            keys.map(key => {
              otherData.data.push({
                name: key,
                ...dataMap[key],
              })
            })
            data = [...top10DataList, otherData]
          }
          top10YAxis = data.map(item => item.name)
          top10YAxis.map((name, index) => {
            yAxisColorMap[name] = this.colors[index] || '#ccc'
          })
          // 整理series
          showBillTypes.map(type => {
            data.map(item => {
              const seriesItem = {
                name: item.name,
                type: 'bar',
                emphasis: {
                  focus: 'series',
                },
                stack: type,
                data: item.data.map(col => col[type]),
                barMaxWidth: 30,
                itemStyle: {
                  color: yAxisColorMap[item.name],
                },
                id: `${item.name}->${type}`,
              }
              series.push(seriesItem)
            })
          })
        }
      }
      return { series, xAxis, top10YAxis, yAxisColorMap }
    },
    exportExcel () {
      this.$emit('exportExcel')
    },
    initChartData () {
      const listData = this.groupLen > 1 && this.showAsDimension2 ? this.getTop10AndOtherDataLevel2(transformAndSumData2(this.originDataList, this.billTypes)) : this.getTop10AndOtherData(transformAndSumData(this.originDataList, this.billTypes))
      const columns = []
      let rows = []
      if (listData.length && listData[0].data && listData[0].data[0] && !listData[0].data[0].data) {
        listData.map(item => {
          columns.push(item.name)
        })
        const initRows = new Array(listData[0].data.length)
        listData.map((item, index) => {
          item.data.map((item2, index2) => {
            if (index === 0) {
              if (!initRows[index2]) initRows[index2] = {}
              initRows[index2][this.$t('bill.date')] = item2.date_info
            }
            initRows[index2] && (initRows[index2][item.name] = item2.stat_value || 0)
          })
        })
        rows = initRows
      }
      if (listData.length && listData[0].data && listData[0].data[0] && listData[0].data[0].data) {
        listData.map(item => {
          item.data.map(item2 => {
            if (!columns.includes(item2.name)) {
              columns.push(item2.name)
            }
          })
        })
        const initRows = new Array(listData.length)
        listData.map((item, index) => {
          initRows[index] = { [this.$t('bill.date')]: item.name }
          item.data.map((item2, index2) => {
            let value = 0
            item2.data.map(item => {
              value += item.stat_value || 0
            })
            initRows[index] && (initRows[index][item2.name] = value)
          })
        })
        rows = initRows
      }
      this.chartData.columns = [this.$t('bill.date'), ...columns]
      this.chartData.rows = rows
    },
    getTop10AndOtherData (dataList) {
      const _dataList = R.clone(dataList)
      const top10DataList = _dataList.slice(0, 10)
      const otherDataList = _dataList.slice(10)
      const len = otherDataList[0]?.data?.length || 0
      const otherData = { name: this.$t('bill.other'), data: [] }

      for (let i = 0; i < len; i++) {
        let sum = 0
        let usageSum = 0
        for (let j = 0; j < otherDataList.length; j++) {
          sum += otherDataList[j].data[i]?.stat_value || 0
          usageSum += otherDataList[j].data[i]?.aggregate_usage || 0
        }
        otherData.data.push({ stat_value: sum, aggregate_usage: usageSum })
      }
      if (otherData.data?.length > 0) {
        top10DataList.push(otherData)
      }
      return top10DataList
    },
    getTop10AndOtherDataLevel2 (dataList) {
      const level2Map = {}
      dataList.forEach(item => {
        item.data.forEach(item2 => {
          if (!level2Map[item2.name]) {
            level2Map[item2.name] = item2.stat_value_sum
          } else {
            level2Map[item2.name] += item2.stat_value_sum
          }
        })
      })
      const list = Object.keys(level2Map).map(key => ({ name: key, stat_value_sum: level2Map[key] }))
      list.sort((a, b) => {
        return b.stat_value_sum - a.stat_value_sum
      })
      const top10List = list.slice(0, 10)
      const result = dataList.map(item => {
        const target = item.data.filter(t => top10List.some(l => l.name === t.name))
        const other = item.data.filter(t => !top10List.some(l => l.name === t.name))
        const otherItem = { name: '其他', stat_value_sum: 0 }
        other.forEach(o => {
          otherItem.stat_value_sum += o.stat_value_sum
        })
        const list = other.length ? [...target, otherItem] : target
        return {
          name: item.name,
          data: list,
        }
      })
      return result
    },
  },
}
</script>
<style lang="scss">
.billanalysis {
  .percent {
    display: inline-block;
    border: 1px solid #4DA1FF;
    color: #4DA1FF;
    height: 18px;
    line-height: 18px;
    padding: 0 6px;
    font-size: 12px;
    font-style: normal;
  }
}
</style>
